module.exports = __webpack_public_path__ + "img/allies.57141589.png";